"use client"

import { useId } from "react"

import { Label } from "@/components/ui/label"
import { Switch } from "@/components/ui/switch"
import { useSetSelfLearningArticlesMutation } from "@/hooks/mutations/self-learning"
import { useSelfLearningQuery } from "@/hooks/queries/self-learning"
import { ARTICLES_OPTION_COPY } from "@/lib/conversation-quality/self-learning-display"

/** Automatic's option to add what the agent learns by itself; shown in Automatic only, locked like the mode. */
export function SelfLearningArticlesSwitch({ agentId, canManage }: { agentId: string; canManage: boolean }) {
  const id = useId()
  const { data } = useSelfLearningQuery(agentId)
  const save = useSetSelfLearningArticlesMutation(agentId)

  if (data?.mode !== "automatic") return null

  return (
    <div className="flex items-start gap-2.5">
      <Switch
        id={id}
        checked={data.addsArticles}
        disabled={!canManage || Boolean(data.qualityDisabledBy) || save.isPending}
        onCheckedChange={(addsArticles) => save.mutate(addsArticles)}
        className="mt-0.5 shrink-0"
      />
      <div className="min-w-0">
        <Label htmlFor={id} className="text-sm font-normal">
          {ARTICLES_OPTION_COPY.label}
        </Label>
        {!data.addsArticles && <p className="text-xs text-muted-foreground">{ARTICLES_OPTION_COPY.off}</p>}
      </div>
    </div>
  )
}
